/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WebApiModelsEnumerationTypesCustomListFieldTypes = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5
} as const;
export type WebApiModelsEnumerationTypesCustomListFieldTypes = typeof WebApiModelsEnumerationTypesCustomListFieldTypes[keyof typeof WebApiModelsEnumerationTypesCustomListFieldTypes];


export function WebApiModelsEnumerationTypesCustomListFieldTypesFromJSON(json: any): WebApiModelsEnumerationTypesCustomListFieldTypes {
    return WebApiModelsEnumerationTypesCustomListFieldTypesFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesCustomListFieldTypesFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesCustomListFieldTypes {
    return json as WebApiModelsEnumerationTypesCustomListFieldTypes;
}

export function WebApiModelsEnumerationTypesCustomListFieldTypesToJSON(value?: WebApiModelsEnumerationTypesCustomListFieldTypes | null): any {
    return value as any;
}

